type ErrorLike = {
  message?: unknown;
} | null;

/**
 * Форматирует массив ошибок в читаемое сообщение
 * Убирает пробелы, добавляет точки, делает заглавную букву, объединяет через пробел
 * Фильтрует null, undefined и пустые сообщения
 */
export const utilFormatErrorMessages = (
  errors?: ErrorLike[] | string | null
): string | null => {
  if (typeof errors === 'string') {
    return errors;
  }

  if (!errors?.length) {
    return null;
  }

  const validMessages = errors
    .filter(
      (error): error is NonNullable<ErrorLike> =>
        !!error?.message && !!String(error.message).trim()
    )
    .map((error) => {
      const msg = String(error.message).trim();
      const msgWithDot = msg.endsWith('.') ? msg : msg + '.';
      return msgWithDot.charAt(0).toUpperCase() + msgWithDot.slice(1);
    });

  return validMessages.length ? validMessages.join(' ') : null;
};
